import React, { useRef, useEffect, useCallback, useState} from 'react';
import {setPianoRollSlide} from 'actions/index.js';
import PianoRollSideControl from '../pianoroll2/PianoRollSideControl.js';
import NoteSidePanelRow from './NoteSidePanelRow.js';
import {connect} from 'react-redux';

const NotesSidePanel = ({
    onMouseOver,
    color,
    onMouseDown,
    onMouseUp,
    onMouseMove,
    notes,
    track,
    notesDown=[],
    pianoRollSlide,
    setSelectedPianoRollSteps,
    setPianoRollSlide,
    scale,
    setScale
}) => { 
    let ref = useRef(undefined);

    useEffect(() => {
        ref.current.addEventListener("mousewheel", onWheel, {passive: false});
        return () => ref.current.removeEventListener("mousewheel", onWheel);
    }, [setScale, scale]);
    
    const onWheel = useCallback((e) => {
        e.preventDefault();
        if (e.ctrlKey) {
            let _scale = scale - e.deltaY * 0.01;
            if (_scale <= 0.4) {
                _scale = 0.4;
            }
            setScale(_scale);
        }
    }, [setScale, scale]);
    return (
        <div ref={ref} className="notes-side-panel">
          <div
            style={{backgroundColor: color}}
            className="side-panel-top">
          </div>
          {notes.map(
                   (note, i) =>
                  <NoteSidePanelRow
                    key={note.getTranspose()}
                    scale={scale}
                    onMouseOver={onMouseOver}
                    isTriggering={notesDown.includes(note.getTranspose())}
                    color={color}
                    onMouseDown={(e) => onMouseDown(e, note, i)}
                    onMouseUp={(e) => onMouseUp(e)}
                    onMouseMove={(e) => onMouseMove(e)}
                         note={note}
                    track={track}
                  />)}
        </div>
    );
    /*<PianoRollSideControl color={color} track={track}/>*/
}

const mapStateToProps = (state, props) => {
  return {
      notesDown: state.keyboard.notesDown,
      pianoRollSlide: state.keyboard.pianoRollSlide,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPianoRollSlide: (x) => dispatch(setPianoRollSlide(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotesSidePanel);
